export { GalleryIcon } from './gallery'
